import auth from '@/apiClient/Auth'
import * as types from './mutationTypes'

const Auth = new auth()

const state = {
  customParams: {
    loginCustom: {
      layout: {
        background: {},
        loginBox: {},
        footer: {}
      },
      login: {
        box: {
          logo: {}
        },
        form: {
          inputs: {},
          labels: {},
          buttons: {},
          buttonSSO: {}
        },
        commerceInfo: {}
      }
    }
  },
  queryParams: {
    params: {
      factory: ''
    }
  }
}

const mutations = {
  [types.LOGIN_CUSTOM_PARAMS](state, data) {
    state.customParams = data
  },
  initialCustomParams(state) {
    if (localStorage.getItem('customParams')) {
      state.customParams = JSON.parse(localStorage.getItem('customParams'))
    }
  },
  [types.SET_PARAM_FACTORY](state, data) {
    state.queryParams.params.factory = data
  }
}

const actions = {
  getFileLoginCustom: async ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      Auth.loginCustomFile(payload)
        .then(response => {
          if (response && response.data && !response.isAxiosError) {
            commit(types.LOGIN_CUSTOM_PARAMS, response.data)
            localStorage.setItem('customParams', JSON.stringify(response.data))
            const country = response.data.loginCustom.country ? response.data.loginCustom.country : 'AR'
            dispatch('setLocale', country, { root: true })
            resolve()
          } else {
            throw new Error('Fallback')
          }
        })
            
        .catch(error => {
          // Fallback to app_login.json if subdomain file doesn't exist
          if (payload !== 'app') {
            Auth.loginCustomFile('app')
              .then(response => {
                if (response && response.data && !response.isAxiosError) {
                  commit(types.LOGIN_CUSTOM_PARAMS, response.data)
                  localStorage.setItem('customParams', JSON.stringify(response.data))
                  const country = response.data.loginCustom.country ? response.data.loginCustom.country : 'AR'
                  dispatch('setLocale', country, { root: true })
                  resolve()
                } else reject(error)
              })
              .catch(() => reject(error))
          } else {
            reject(error)
          }
        })
    })
  },
  ssoAuthLogin: (_, ssoToken) => {
    return new Promise((resolve, reject) => {
      Auth.loginSSO(ssoToken).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  setParamLoginFactory: ({ commit }, factory) => {
    commit(types.SET_PARAM_FACTORY, factory)
    localStorage.setItem('factory', factory)
  }
}

const getters = {
  getLoginCustomParams: state => {
    return state.customParams
  },
  getFactoryStringParam: state => {
    return state.queryParams.params.factory
  }
}

const AuthModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default AuthModule
